import React from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { actions } from '../../PendingReceivementsState'
import { WrongProductsTables } from './WrongProductsTables'
import { ReceivementConferenceTables } from './ReceivementConferenceTables'
import { Footer, TablesContainer } from './PendingReceivement.style'
import { InvoiceSelectAndView } from 'src/components/InvoiceSelectAndView'
import { useSelector } from 'src/utils/store'
import { ForwardButton } from './ReceivementConferenceTables/ForwardButton'
import { InvoicesManagement } from './InvoicesManagement'
import { Typography } from '@mui/material'
import { ReceivementCategoryEnum } from '../../PendingReceivementsTypes'

export const PendingReceivement = () => {
  const dispatch = useDispatch()
  const { receivementId } = useParams<{ receivementId?: string }>()
  const receivementConference = useSelector((state) => state.pendingReceivements.receivementConference)
  const badge = useSelector((state) => state.pendingReceivements.badge)
  const history = useHistory()

  React.useEffect(() => {
    if (!receivementId) return

    if (!badge) {
      history.push(`/pending-receivement/${receivementId}/badge`)
      return
    }

    dispatch(actions.getReceivementConference({ badge, receivementId: parseInt(receivementId, 10) }))
  }, [dispatch, badge, receivementId, history])

  return (
    <TablesContainer>
      {receivementConference?.idReceivementCategory === ReceivementCategoryEnum.NORMAL && (
        <InvoicesManagement
          receivementId={receivementId!}
          invoiceKeys={receivementConference?.allReceivementInvoices || []}
          badge={badge || ''}
        />
      )}
      <InvoiceSelectAndView
        nfList={receivementConference?.nfList || []}
      />

      {(receivementConference?.receivementConference.length === 0 && receivementConference?.productWrong.length === 0) && (
        <Typography variant='h5' align='center'>
          Não há produtos para conferência
        </Typography>
      )}

      <WrongProductsTables
        wrongProducts={receivementConference?.productWrong}
        receivementId={receivementId}
        badge={badge}
      />

      {receivementConference?.idReceivementCategory === ReceivementCategoryEnum.NORMAL && (
        <ReceivementConferenceTables
          receivementConference={receivementConference?.receivementConference}
          wrongProducts={receivementConference?.productWrong}
        />
      )}

      <Footer>
        <ForwardButton receivementId={receivementId} />
      </Footer>
    </TablesContainer>
  )
}
